/** HELM's views and which one a route belongs to (A7Y-5210); the bar is `HelmViews.tsx`. */

export const HELM_VIEWS = [
  { id: 'today', label: 'Today', to: '/admin/cmo/helm' },
  { id: 'week', label: 'This week', to: '/admin/cmo/crm/this-week' },
  { id: 'board', label: 'Board', to: '/admin/cmo/crm/board' },
  { id: 'accounts', label: 'Accounts', to: '/admin/cmo/crm' },
] as const;

export type HelmViewId = (typeof HELM_VIEWS)[number]['id'];

/** The view a HELM route belongs to: the account pages (`/admin/cmo/crm/<id>`) are Accounts. */
export function helmViewOf(pathname: string): HelmViewId | null {
  const path = pathname.replace(/\/+$/, '');
  if (path === '/admin/cmo/helm' || path.startsWith('/admin/cmo/helm/')) return 'today';
  if (path === '/admin/cmo/crm/this-week') return 'week';
  if (path === '/admin/cmo/crm/board') return 'board';
  if (path === '/admin/cmo/crm' || path.startsWith('/admin/cmo/crm/')) return 'accounts';
  return null;
}
